import { css } from '@emotion/core'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getBooleanDisplayValue } from '../../../../../util/StringUtil'

const contentPadding = css`
  padding-top: 0px;
  padding-inline-end: 16px;
  padding-bottom: 16px;
  padding-inline-start: 16px;
`

export default function AccessControl({ accessControl }) {
  const { t } = useTranslation()
  let ownerHeading = accessControl.ownerCisId && t('owner.ownerCisId', 'Owner CIS ID')
  if (!ownerHeading) {
    ownerHeading = accessControl.ownerGroupId && t('ownerGroupId', 'Owner Group ID')
  }
  if (!ownerHeading) {
    ownerHeading = t('owner', 'Owner')
  }
  return (
    <div css={contentPadding}>
      <Grid>
        <Cell columns={3}>
          <DataBlock
            heading={`${ownerHeading}:`}
            data={accessControl.ownerCisId || accessControl.ownerGroupId || t('public', 'Public')}
            inline
          />
          <DataBlock
            heading={`${t('hidden', 'Hidden')}:`}
            data={getBooleanDisplayValue(accessControl.hidden) ?? ''}
            inline
          />
          <DataBlock
            heading={`${t('accessControl.locked', 'Locked')}:`}
            data={getBooleanDisplayValue(accessControl.locked) ?? ''}
            inline
          />
        </Cell>
        <Cell columns={3}>
          <DataBlock
            heading={`${t('tools.adminMerge.labels.hideCompleteOrdinances', 'Hide Complete Ordinances')}:`}
            data={getBooleanDisplayValue(accessControl.hideCompletedOrdinances) ?? ''}
            inline
          />
          <DataBlock
            heading={`${t('accessControl.ordApprovalRequired', 'Ordinance Approval Required')}:`}
            data={getBooleanDisplayValue(accessControl.ordinanceApprovalRequired) ?? ''}
            inline
          />
          <DataBlock
            heading={`${t('tools.adminMerge.labels.sensitiveOwnerRestricted', 'Sensitive/Owner Restricted')}:`}
            data={getBooleanDisplayValue(accessControl.ownerRestricted) ?? ''}
            inline
          />
        </Cell>
      </Grid>
    </div>
  )
}
